











import Vue, { PropType } from 'vue';
import { mapGetters } from 'vuex';
import VideoModel from '@/dex-shared/models/VideoModel';
import VideoEditorComponent from '@/components/VideoEditorComponent.vue';

export default Vue.extend({
  components: {
    VideoEditorComponent,
  },
  computed: {
    videoId() {
      return +this.$route.params.videoId;
    },
  },
  methods: {
    updatePage() {
      location.reload();
    },
  },
});
